angular
    .module('app.factories')
    .factory('listFilter', ($q, $injector, $localStorage, $translate, $stateParams, $timeout, $log, clientsService, routeResolver, notify, variables) => {
        const filter = {
            name: 'simpleFilter',
            visible: false,
            active: false,
            extendByDates: true,
            fields: {},
            saveLastConfig: true,
            currentConfigName: '',
            lastChange: 0,
            changeCallback: angular.noop,
            refreshCallback: angular.noop,
            showStats: !variables.mobileMode,
            providers: [],

            isVisible() {
                return filter.visible;
            },

            isActive(check) {
                if ('undefined' !== typeof check && check) {
                    let active = false;
                    const ignore = ['changed'];

                    angular.forEach(filter.fields, (field, name) => {
                        if (ignore.includes(name)) {
                            return false;
                        }

                        if (typeof field.value !== 'object' && field.value && field.value != field.default) {
                            active = true;
                            return true;
                        }
                    });
                    filter.active = active;
                }

                return filter.active;
            },

            setName(name) {
                filter.name = name;

                return filter;
            },

            setAttributes(attributes) {
                angular.forEach(attributes, (value, name) => {
                    if (filter.hasOwnProperty(name)) {
                        filter[name] = value;
                    }
                });

                return filter;
            },

            setFields(fields) {
                filter.fields = fields;

                angular.extend(filter.fields, {
                    changed: {
                        type: 'hidden',
                    },
                });

                // przygotowujemy pola
                angular.forEach(filter.fields, (properties, field) => {
                    if ('checkbox-list' == properties.type) {
                        properties.value = {};

                        angular.forEach(properties.names, (checkbox) => {
                            properties.value[checkbox.name] = properties.value[checkbox.name] || properties.default[checkbox.name] || '0';
                        });
                    } else {
                        properties.value = properties.value || properties.default || '';
                    }
                });

                if (filter.extendByDates) {
                    angular.extend(filter.fields, {
                        created_at_from: {
                            type: 'date',
                            class: 'uk-width-medium-1-4',
                            label: $translate.instant('filter.created_at_from'),
                        },
                        created_at_to: {
                            type: 'date',
                            class: 'uk-width-medium-1-4',
                            label: $translate.instant('filter.created_at_to'),
                        },
                        updated_at_from: {
                            type: 'date',
                            class: 'uk-width-medium-1-4',
                            label: $translate.instant('filter.updated_at_from'),
                        },
                        updated_at_to: {
                            type: 'date',
                            class: 'uk-width-medium-1-4',
                            label: $translate.instant('filter.updated_at_to'),
                        },
                        deleted_at_from: {
                            type: 'date',
                            class: 'uk-width-medium-1-4',
                            label: $translate.instant('filter.deleted_at_from'),
                        },
                        deleted_at_to: {
                            type: 'date',
                            class: 'uk-width-medium-1-4',
                            label: $translate.instant('filter.deleted_at_to'),
                        },
                        with_deleted: {
                            type: 'list',
                            class: 'uk-width-medium-1-4',
                            label: $translate.instant('filter.with_deleted'),
                            options: [
                                { value: 'none', label: $translate.instant('filter.with_deleted_none') },
                                { value: 'also', label: $translate.instant('filter.with_deleted_also') },
                                { value: 'only', label: $translate.instant('filter.with_deleted_only') },
                            ],
                            value: '',
                        },
                        limit: {
                            type: 'list',
                            class: 'uk-width-medium-1-4',
                            label: $translate.instant('filter.max_results'),
                            options: [
                                { value: 10, label: 10 },
                                { value: 30, label: 30 },
                                { value: 50, label: 50 },
                                { value: 100, label: 100 },
                                { value: 150, label: 150 },
                                { value: 200, label: 200 },
                                { value: 300, label: 300 },
                                { value: 500, label: 500 },
                            ],
                            default: variables.mobileMode ? 10 : 30,
                        },
                        reset: {
                            type: 'reset',
                            class: 'uk-width-medium-1-1',
                        },
                    });
                }

                return filter;
            },

            toggle(state) {
                if ('undefined' === typeof state) {
                    state = !filter.visible;
                }

                filter.visible = state;

                return filter;
            },

            clear(refresh) {
                angular.forEach(filter.fields, (field) => {
                    field.value = field.default || '';
                });
                filter.active = false;

                if ('undefined' !== typeof refresh && refresh) {
                    filter.refresh();
                }

                return filter;
            },

            refresh() {
                filter.fields.changed.value = moment().format('x');

                if (filter.saveLastConfig) {
                    filter.autosave();
                }

                $timeout(() => {
                    $log.debug(`filter.refresh: ${filter.name}`);
                    filter.refreshCallback();
                }, 250);

                return filter;
            },

            changed() {
                filter.changeCallback();

                if (filter.saveLastConfig) {
                    filter.autosave();
                }

                filter.isActive(true);
                filter.lastChange = moment().format('x');

                return filter;
            },

            autosave(rowName) {
                const data = {};
                const name = rowName || $translate.instant('filter.last_used');
                const storage = filter.getStorage();

                angular.forEach(filter.fields, (attributes, field) => {
                    if ('undefined' !== typeof attributes.value) {
                        data[field] = attributes.value;
                    }
                });

                $log.debug(`autosaved filter: ${name}`, data);
                storage[name] = data;

                return filter;
            },

            save() {
                UIkit.modal.prompt($translate.instant('filter.name'), '', (filterName) => {
                    filter.autosave(filterName);
                    notify.success($translate.instant('filter.saved'));
                });

                return filter;
            },

            getStorage() {
                const cacheKey = `filter_${filter.name}`;

                if ('object' !== typeof $localStorage[cacheKey]) {
                    $localStorage[cacheKey] = {};
                }

                return $localStorage[cacheKey];
            },

            onChange(callback) {
                filter.changeCallback = callback;

                return filter;
            },

            onRefresh(callback) {
                filter.refreshCallback = callback;

                return filter;
            },

            getValues(strict) {
                const fields = {};

                angular.forEach(filter.fields, (field, name) => {
                    if (strict) {
                        if (field.value !== field.default) {
                            fields[name] = field.value || '';
                        }
                    } else {
                        fields[name] = {
                            operator: field.operator || 'like',
                            value: field.value || '',
                        };
                    }
                });
                $log.debug('get values: strict? ', strict ? 'yes' : 'no', fields);

                return fields;
            },

            fieldId(fieldName) {
                return `vpsf_${filter.name}_${fieldName}`;
            },

            prefill() {
                // 1. $stateParams
                if (Object.keys($stateParams.filter || {}).length) {
                    $log.debug('prefilled with params: ', $stateParams.filter);
                    return filter.fillWithValues($stateParams.filter);
                }

                // 2. last used config
                const filterName = $translate.instant('filter.last_used');
                filter.fillUsing(filterName);
                $log.debug(`prefilled with filter: ${filterName}`, filter.getValues());

                return filter;
            },

            fillUsing(filterName) {
                const storage = filter.getStorage();

                if (!angular.isUndefined(storage[filterName])) {
                    angular.forEach(storage[filterName], (value, fieldName) => {
                        if (filter.fields[fieldName]) {
                            filter.fields[fieldName].value = value;
                        }
                    });
                    filter.currentConfigName = filterName;
                }

                filter.isActive(true);

                return filter;
            },

            fillWithValues(filterData) {
                angular.forEach(filterData, (value, name) => {
                    if ('object' === typeof filter.fields[name]) {
                        filter.fields[name].value = value;
                    }
                });

                filter.isActive(true);

                return filter;
            },

            updateClientsOptions(field) {
                const clientId = parseInt(filter.fields[field].value || 0);

                if (clientId) {
                    clientsService.findForFilter(clientId).then((options) => {
                        filter.fields[field].options = options;
                    });
                }
            },

            getProviders(deferred) {
                if (_.isArray(filter.providers) && filter.providers.length) {
                    const promises = [];
                    const options = {};

                    $log.debug('provider to fetch', filter.providers);
                    angular.forEach(filter.providers, (providerName) => {
                        $log.debug(`get provider for filter ${providerName}`, routeResolver[providerName]);

                        const injected = $injector.invoke(routeResolver[providerName]);
                        if (_.isObject(injected.$$state)) {
                            promises.push(
                                injected.then((data) => {
                                    options[providerName] = data;
                                    $log.debug(`fetched by promise ${providerName}: `, data);
                                })
                            );
                        } else {
                            options[providerName] = injected;
                            $log.debug(`fetched directly ${providerName}: `, injected);
                        }
                    });

                    $q.all(promises).then(() => {
                        filter
                            .setAttributes({
                                providers: options,
                            })
                            .ready();

                        return deferred.resolve(filter);
                    });
                } else {
                    // jeżeli jest już obiektem, to od razu zwracamy
                    deferred.resolve(filter);
                }
            },

            ready(callback) {
                // przygotowujemy pola
                angular.forEach(filter.fields, (properties, field) => {
                    if ('string' === typeof properties.optionsProvider && 'undefined' !== typeof filter.providers[properties.optionsProvider]) {
                        properties.options = filter.providers[properties.optionsProvider];
                    }
                });

                if (filter.saveLastConfig && '' === filter.currentConfigName) {
                    filter.fillUsing($translate.instant('filter.last_used'));
                }

                if ('function' === typeof callback) {
                    callback();
                }

                return filter;
            },
        };

        return filter;
    });
